import { render, staticRenderFns } from "./employer.vue?vue&type=template&id=fd89332c&scoped=true"
import script from "./employer.vue?vue&type=script&lang=js"
export * from "./employer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.23_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_t2asupwbbn4g4z6gf7kzzdxifm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd89332c",
  null
  
)

export default component.exports